import { Url } from '../shared/Url';
import Post from '../shared/Post';
import { cookieData } from '../funciones/ConsultaUser';

export const CantTransaccionesDia = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
        }

        Post(`${Url}cantTransaccionesDia`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });
}

export const TransaccionesDia = (pagina, cantidad, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            pagina: pagina,
            cantidad: cantidad
        }

        Post(`${Url}TransaccionesDia`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data[0])
        });
    });
}

export const CantTransaccionesMes = (mes, year, hist, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            mes: mes,
            year: year,
            hist: hist
        }

        Post(`${Url}cantTransaccionesMes`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });
}

export const TransaccionesMes = (mes, pagina, cantidad, year, hist, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            mes: mes,
            pagina: pagina,
            cantidad: cantidad,
            year: year,
            hist: hist
        }

        Post(`${Url}TransaccionesMes`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data[0])
        });
    });
}

export const CantTransaccionesRango = (fecha1, fecha2, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            fecha1: fecha1,
            fecha2: fecha2
        }

        Post(`${Url}cantTransaccionesRango`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });
}

export const TransaccionesRango = (fecha1, fecha2, pagina, cantidad, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            fecha1: fecha1,
            fecha2: fecha2,
            pagina: pagina,
            cantidad: cantidad
        }

        Post(`${Url}TransaccionesRango`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data[0])
        });
    });
}

export const CantTransaccionesSeccion = (seccion, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            seccion: seccion
        }

        Post(`${Url}cantTransaccionesSeccion`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });
}

export const TransaccionesSeccion = (seccion, pagina, cantidad, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            seccion: seccion,
            pagina: pagina,
            cantidad: cantidad
        }

        Post(`${Url}TransaccionesSeccion`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data[0][0])
        });
    });
}

export const CantTransaccionesEst = (string, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            strings: string
        }

        Post(`${Url}cantTransaccionesEst`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });
}

export const TransaccionesEst = (string, pagina, cantidad, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            strings: string,
            pagina: pagina,
            cantidad: cantidad
        }

        Post(`${Url}TransaccionesEst`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data[0])
        });
    });
}

export const ConsultaTasas = (respuesta) => {
    Post(`${Url}ConsultaTasas`, "", (resp) => {
        let data = JSON.parse(resp)
        respuesta(data)
    });
}

export const AddItem = (item, uc, act, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            item: item,
            uc: uc,
            act: act,
            uId: cookie[1]
        }

        Post(`${Url}AddItem`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });
}

export const EditItem = (idItem, item, uc, act, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            id: idItem,
            item: item,
            uc: uc,
            act: act,
            uId: cookie[1]
        }

        Post(`${Url}EditItem`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });
}

export const DelItem = (idItem, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            id: idItem,
            uId: cookie[1]
        }

        Post(`${Url}DelItem`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });
}


// WEBPACK FOOTER //
// ./src/funciones/IngresosFunction.jsx